import React from 'react';
import styles from './badgeIcon.module.scss';
import { mergeClassNames } from '../../utils/classNameUtils';

export interface IProps {
    count: number;
    className?: string;
}

export const BadgeIcon: React.FC<IProps> = ({
    count,
    className,
}) => count <= 0
    ? null
    : (
        <span className={mergeClassNames([ styles['container'], className ])}>
            {count > 9 ? '9+' : count}
        </span>
    );

export default BadgeIcon;